var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-box"},[_c('ScaleBox',{attrs:{"width":1920,"height":1080,"bgc":"transparent","delay":1,"isFlat":true}},[_c('newheader'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }